import logoEN from "../assets/plogoE.png";
import logoAR from "../assets/plogoA.png";
import React from "react";
import { auth } from "../firebase/firebaseConfig";
import { signOut } from "firebase/auth";
import { useTranslation } from "react-i18next";

const Header = ({ user }) => {
  const { t, i18n } = useTranslation();
  const handleLogout = async () => {
    try {
      await signOut(auth);
      window.location.href = "/";
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };
  const toggleLanguage = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
  };

  return (
    <div className="flex justify-center">
      <div className="w-full max-w-5xl bg-[#f1efe7] shadow-sm px-6 py-4 rounded-b-lg flex items-center justify-between">
        <img
          src={i18n.language === "ar" ? logoAR : logoEN}
          alt="ath.ar advisory logo"
          className="h-16"
        />

        <div className="flex items-center gap-4">
          <button
            onClick={toggleLanguage}
            className="px-3 py-1 text-sm rounded-full bg-[#b22222] text-white hover:bg-red-800 transition"
          >
            {i18n.language === "ar" ? "🌐 English" : "🌐 العربية"}
          </button>

          {user && (
            <div className="text-sm text-gray-700 text-right">
              <div className="font-semibold">{user.name || user.email}</div>
              <div className="text-xs text-gray-500 capitalize">
                <span className="capitalize">
                  {t(`role_${user.role}`)}
                  {user?.club && ` | ${user.club}`}
                </span>
              </div>
            </div>
          )}
          <button
            onClick={handleLogout}
            className="text-sm bg-[#b22222] text-white px-4 py-2 rounded hover:bg-red-800 transition"
          >
            {t("logout")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;

